import { supabase } from '../supabaseClient';

export const uploadFile = async (bucket: string, file: File, path?: string): Promise<string> => {
  const fileName = path ? path : `${Date.now()}_${file.name.replace(/\s+/g, '_')}`;
  const { error } = await supabase.storage.from(bucket).upload(fileName, file, { upsert: true });

  if (error) throw error;
  const { data: publicUrlData } = supabase.storage.from(bucket).getPublicUrl(fileName);
  return publicUrlData.publicUrl;
};

export const getFullImageUrl = (path: string | null | undefined): string | undefined => {
  if (!path) return undefined;
  if (path.startsWith('http') || path.startsWith('data:') || path.startsWith('blob:')) return path;
  const { data } = supabase.storage.from('public_pic').getPublicUrl(path);
  return data.publicUrl;
};

/**
 * Génère une URL signée pour un fichier du bucket privé 'proofs' (prepend/JS SDK).
 * Si `preuveUrl` n'est pas une URL de ce bucket, la valeur d'origine est renvoyée.
 */
export const getProofSignedUrl = async (preuveUrl: string): Promise<string> => {
  const marker = '/object/public/proofs/';
  const idx = preuveUrl.indexOf(marker);
  if (idx === -1) return preuveUrl;
  const path = preuveUrl.slice(idx + marker.length);
  const { data, error } = await supabase.storage.from('proofs').createSignedUrl(path, 3600);
  if (error || !data?.signedUrl) return preuveUrl;
  return data.signedUrl;
};
